import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';



export default function LoadingScreen(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            borderRadius: () => props.noRadius ? 0 : 3,
            width: "100%",
            height: "100%",
            position: "absolute",
            backgroundColor: () => props.opacity ? `rgba(0,0,0,${props.opacity})` : "rgba(0,0,0,0.2)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 500,
            color: "white"
        },
    }));

    const classes = useStyles(props);

    if (props.status) {
        return (
            <div className={classes.root}>
                <CircularProgress color="inherit" />
                {props.text &&
                    <Typography variant="body1" style={{ marginTop: 8 }}>{props.text}</Typography>
                }
                {props.hint &&
                    <Typography variant="body2" style={{ marginTop: 8 }}>{props.hint}</Typography>
                }
            </div>
        );
    }
    return null;
}

